import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Download, Trash2 } from 'react-feather';

// Imports custom
import {
    FileManagerList,
    TooltipInformation,
    // LinearLoading,
    CustomDropDown
} from 'common'

const AdminFilesTable = ({useFetchInit}) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const {FormFiles} = Forms
    const {formState} = FormFiles

        
    const {formOpeningMode } = globalStates 

    const {handleClickDeleteDocument} = Actions

    const cellRendererTooltip = (params) => {
        //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
        const {iddocumento, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
        return(
            <TooltipInformation 
                idregistro={iddocumento}
                usuario_creo={usuario_creo}
                fecha_creo={fecha_creo}
                usuario_modifico={usuario_modifico}
                fecha_modifico={fecha_modifico}
            />
        )
    }

    const cellRendererOptions = (params) => {

        const { iddocumento, document_path, department, estado } = params.data
        return (
            <CustomDropDown color={(estado===1)?'inherit':'error'}>
                <MenuItem
                    component="a"
                    href={document_path} 
                    target="_blank" 
                >
                    <ListItemIcon> <Download color="black"/> </ListItemIcon>
                    <ListItemText primary="Descargar" />
                </MenuItem>
                {((formOpeningMode==='EDITABLE') && (department=== 'JURIDICO')) && (
                    <MenuItem
                        onClick={() => handleClickDeleteDocument(iddocumento)}
                    >
                        <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                        <ListItemText primary="Eliminar" />
                    </MenuItem>
                )}
            </CustomDropDown>
        )
        
    }

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info", 
            minWidth: 80,
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: cellRendererTooltip
        },
        { field: "document_originalname", headerName: "NOMBRE DEL ARCHIVO", minWidth: 250, filter: true },
        { field: "department", headerName: "DEPARTAMENTO", minWidth: 250, filter: true },
        {
            headerName: "OPCIONES",minWidth: 300,
            cellRenderer: cellRendererOptions
        },
    ]

    
    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <FileManagerList
            rowConfig={formState.files}
            columnConfig={columnConfig}
        />
    )
    
}

export {
    AdminFilesTable
}